import React from "react";
import { FormattedMessage } from "react-intl";
import { Card, Row, Space } from "@masterteam/mt-design-react";

import DoughnutChart from "../../../DoughnutChart";
import KPIStatusIndicator from "../../../KPIStatusIndicator";

import { ReactComponent as ChartIcon } from "../../../../assets/images/bar-chart.svg";

import "./style.scss";

const SummaryCard = ({
  data,
  title,
  detailsTitle,
  detailsData,
  statuses,
  totalCount,
  isProject = false,
}) => {
  return (
    <Card className="dashboard-summary-card">
      <Row className="dashboard-summary-card__title" align="center" gap={8}>
        <ChartIcon />
        <FormattedMessage id={title} />
      </Row>

      <Row className="dashboard-summary-card_chart" justify="center">
        <DoughnutChart
          data={data || []}
          statuses={statuses}
          count={totalCount}
          detailsTitle={detailsTitle}
          detailsData={detailsData}
          showNoData
          isProject={isProject}
        />
      </Row>

      <Row
        className="dashboard-summary-card__statuses"
        justify="center"
        size="medium"
        wrap
      >
        {statuses.map((_item, index) => (
          <KPIStatusIndicator item={_item} key={index} />
        ))}
      </Row>
    </Card>
  );
};

export default SummaryCard;
